"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpenCloseTime = exports.locationAvailabilityMessage = exports.isLocationClosed = exports.isHappeningNow = exports.isHolidayToday = exports.formattedHolidaysList = exports.SERVICE_HOLIDAYS_FOR_PRIVATE_CENTRES = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const dayOfWeek_1 = __importStar(require("./dayOfWeek"));
const models_1 = require("./models");
// These need to be written the same way as they are returned from the API
const CHRISTMAS_DAY = "Christmas Day";
const BOXING_DAY = "Boxing Day";
const NEW_YEARS_DAY = "New Year's Day";
// These are the two holidays where, if they fall on the weekend, even private centres take Monday off.
// Private centres don't necessarily take Monday off for other holidays on the weekend (i.e. New Year's Day). If they choose to do so, a custom closure message can be added.
exports.SERVICE_HOLIDAYS_FOR_PRIVATE_CENTRES = [
    CHRISTMAS_DAY,
    BOXING_DAY,
    NEW_YEARS_DAY,
];
/**
 * Take a date string and format it for the current language
 * @param {*} dateString  date string in format MM-DD-YYYY
 * @param {*} language    language to use
 */
const formattedDate = (dateString, language) => {
    if (!dateString) {
        return "";
    }
    const dateComponents = dateString.split("-").map(Number);
    const date = new Date(dateComponents[2], dateComponents[0] - 1, dateComponents[1]);
    let formattedDate = new Intl.DateTimeFormat(`${language}-CA`, {
        weekday: "long",
        month: "long",
        day: "numeric",
    }).format(date);
    if (language === "fr") {
        formattedDate = formattedDate.replace(" 1 ", " 1er ");
    }
    return formattedDate;
};
/**
 * Create a list of formatted holiday callout items based on the list of upcoming holidays
 * @param {*} locationType  type of location
 * @param {*} language      current language
 * @param {*} availability  availability information for location
 * @param {*} holidays      list of upcoming holidays
 * @param {*} t             wording translation object
 *
 * NOTE: A similar algorithm is used in other places as well. See API project README for more information.
 * Ensure that ALL locations using this algorithm are updated.
 */
const formattedHolidaysList = (locationType, language, availability, holidays, t) => {
    const holidayList = []; // List of text content for each holiday coming up
    const isPublic = locationType === "SO_CNTR";
    let sameForAllLocations = true; // Flag whether the holidays message is the exact same for all locations (public and private)
    let isToday = false; // Is a holiday happening today?
    for (let i = 0; i < holidays.length; i++) {
        const holiday = holidays[i];
        let momentHoliday = moment_timezone_1.default.tz(holiday.date, "MM-DD-YYYY", availability.timezone);
        // Check if there is an existing custom closure message that overrides the holiday message
        if (false && availability.notices) {
            let foundOverlappingNotice = false;
            for (let i = 0; i < availability.notices.length; i++) {
                const notice = availability.notices[i];
                if ((0, exports.isHappeningNow)(availability.timezone, notice.start_time, notice.end_time, momentHoliday)) {
                    foundOverlappingNotice = true;
                    break;
                }
            }
            if (foundOverlappingNotice) {
                // Don't show the holiday message
                continue;
            }
        }
        // Private locations need to take only stat holidays
        if (!isPublic && !holiday.stat) {
            continue;
        }
        // If this is a statutory holiday, then the holiday list/messaging is not the same for all locations. Flag for later in the code
        if (!holiday.stat) {
            sameForAllLocations = false;
        }
        // If the holiday is not on Sunday, then show the callout for both private and public locations
        // Even if it is on Saturday, all private and public locations should show the closure for consistency (some private locations are open on Saturday)
        // Second, if this is a non-statutory holiday, we know this is a public location at this point. Don't show the holiday if it's the weekend.
        // Third, make sure this is not in the past (can happen if the API is not yet updated or there is a future service holiday)
        if (momentHoliday.isoWeekday() !== 7 &&
            (holiday.stat || momentHoliday.isoWeekday() < 6) &&
            momentHoliday.isSameOrAfter(moment_timezone_1.default.tz(availability.timezone).startOf("day"))) {
            holidayList.push({
                text: [
                    formattedDate(holiday.date, language),
                    t("for"),
                    language === "en" ? holiday.english : holiday.french,
                ].join(" "),
                date: holiday.date
            });
            if ((0, exports.isHolidayToday)(holiday.date, availability.timezone)) {
                isToday = true;
            }
        }
        // At this point forward, we are working with the service holiday if available
        if (holiday.serviceHoliday) {
            sameForAllLocations = false; // Service holidays can be overridden for any particular location
            momentHoliday = moment_timezone_1.default.tz(holiday.serviceHoliday, "MM-DD-YYYY", availability.timezone);
            // Ignore the service holiday if it is in the past (the API has not yet updated)
            if (!momentHoliday.isSameOrAfter(moment_timezone_1.default.tz(availability.timezone).startOf("day"))) {
                continue;
            }
            // Private centres only take certain "service holidays" that are listed in the array (For Christmas, Boxing Day, or New Years)
            // Another rule is that private locations only take Monday off and not Tuesday, even if Christmas and Boxing Day were both on the weekend
            //Removed condition that only allowed Monday as a service holiday for private locations
            //Logic may need to be updated to restrict to one day if Monday and Tuesday can both be service holidays
            const privateLocationTakesServiceHoliday = exports.SERVICE_HOLIDAYS_FOR_PRIVATE_CENTRES.indexOf(holiday.english) !== -1; //&& momentHoliday.isoWeekday() === 1
            if (isPublic || privateLocationTakesServiceHoliday) {
                holidayList.push({
                    text: formattedDate(holiday.serviceHoliday, language),
                    date: holiday.serviceHoliday
                }); // Don't say what holiday this is for since it's a service holiday and not the actual holiday date
                if ((0, exports.isHolidayToday)(holiday.serviceHoliday, availability.timezone)) {
                    isToday = true;
                }
            }
            // If private locations don't take the service holiday, then the holiday list/messaging is not the same for all locations. Flag for later in the code
            // Commented out since all service holidays are currently flagged
            // if(!privateLocationTakesServiceHoliday){
            //     sameForAllLocations = false;
            // }
        }
    }
    switch (holidayList.length) {
        case 0:
            return null;
        case 1:
            const sortedHolidayList1 = holidayList.sort((a, b) => (0, moment_timezone_1.default)(a.date) > (0, moment_timezone_1.default)(b.date) ? -1 : 0).map(x => x.text);
            return {
                isToday,
                message: ((0, jsx_runtime_1.jsxs)("p", { children: [sameForAllLocations
                            ? isToday
                                ? `${t("serviceOntarioIsClosed")} ${t("today")},`
                                : t("serviceOntarioWillBeClosed")
                            : isToday
                                ? t("areClosed")
                                : t("willBeClosed"), " ", sortedHolidayList1[0], "."] })),
            };
        default:
            const sortedHolidayList2 = holidayList.sort((a, b) => (0, moment_timezone_1.default)(a.date) < (0, moment_timezone_1.default)(b.date) ? -1 : 0).map(x => x.text);
            return {
                isToday,
                message: ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { children: [sameForAllLocations
                                    ? isToday
                                        ? t("serviceOntarioIsClosed")
                                        : t("serviceOntarioWillBeClosed")
                                    : isToday
                                        ? t("areClosed")
                                        : t("willBeClosed"), t("colon")] }), (0, jsx_runtime_1.jsx)("ul", Object.assign({ className: "ontario-margin-bottom-0-!" }, { children: sortedHolidayList2.map((holiday) => ((0, jsx_runtime_1.jsx)("li", { children: holiday }, holiday))) }))] })),
            };
    }
};
exports.formattedHolidaysList = formattedHolidaysList;
/**
 * Check if today is a holiday in the selected timezone
 * @param {*} holiday   holiday date in format MM-DD-YYYY
 * @param {*} timezone  timezone
 */
const isHolidayToday = (holiday, timezone) => {
    return (moment_timezone_1.default
        .tz(holiday, "MM-DD-YYYY", timezone)
        .isSame(moment_timezone_1.default.tz(timezone), "day"));
};
exports.isHolidayToday = isHolidayToday;
/**
 * Check if a time is within the specified range
 * @param {*} timezone     timezone of location
 * @param {*} startDate    start time in ms since epoch
 * @param {*} endDate      end time in ms since epoch
 * @param {*} dateToCheck  check if this date (moment object) is within the time range, or null to use current datetime
 */
const isHappeningNow = (timezone = "America/Toronto", startTime, endTime, dateToCheck = null) => {
    const momentToCheck = dateToCheck || moment_timezone_1.default.tz(timezone);
    return (momentToCheck.isSameOrAfter(moment_timezone_1.default.tz(startTime, timezone)) &&
        momentToCheck.isBefore(moment_timezone_1.default.tz(endTime, timezone)));
};
exports.isHappeningNow = isHappeningNow;
/**
 * Check if a location is closed right now
 * @param {*} schedule  location schedule
 */
const isLocationClosed = (schedule) => {
    if (schedule) {
        const currentTime = moment_timezone_1.default.tz(schedule.timezone);
        const closesTime = moment_timezone_1.default.tz(schedule.closes_time, schedule.timezone); // null if closes_time is null
        const opensTime = moment_timezone_1.default.tz(schedule.opens_time, schedule.timezone);
        const afterCloseTime = closesTime ? currentTime >= closesTime : null;
        const beforeOpenTime = opensTime ? currentTime < opensTime : null;
        if (!schedule.opens_time && !schedule.closes_time) {
            // Temporary closure with no re-open time
            return true;
        }
        else if (!schedule.opens_time) {
            return afterCloseTime;
        }
        else if (!schedule.closes_time) {
            // This should never happen. TODO: log this error.
            return null;
        }
        if (currentTime >= opensTime && currentTime >= closesTime) {
            // We don't know the next open/close time (should never happen)
            return null;
        }
        // The next open time may come after the close time if the location is currently open or it closed for the day already.
        // This is why we need to check for both scenarios.
        if (schedule.opens_time < schedule.closes_time) {
            // If the API returned an open and close time on the same day, check if we are outside of that range
            return afterCloseTime || beforeOpenTime;
        }
        else {
            // If the API returned an open and close time on different days, check if we are between the two times
            return afterCloseTime && beforeOpenTime;
        }
    }
    return null;
};
exports.isLocationClosed = isLocationClosed;
/**
 * Return the message to show for the opening or closing time of a location
 * @param {*} schedule    location schedule
 * @param {*} language    language
 * @param {*} t           translation object
 */
const locationAvailabilityMessage = (language, t, schedule, availabilityErr) => {
    if (availabilityErr) {
        return t("availabilityError");
    }
    if (schedule) {
        let finalMessageComponents = [];
        const locationClosed = (0, exports.isLocationClosed)(schedule);
        // If:
        // 1. We are in the middle of a long-term closure
        // 2. We don't know when the location will re-open for some reason
        if ((locationClosed && !schedule.opens_time) || locationClosed === null) {
            return "";
        }
        let eventDate;
        if (locationClosed) {
            // Open message
            finalMessageComponents.push(t("opens"));
            eventDate = moment_timezone_1.default.tz(schedule.opens_time, schedule.timezone);
        }
        else {
            // Close message
            finalMessageComponents.push(t("closes"));
            eventDate = moment_timezone_1.default.tz(schedule.closes_time, schedule.timezone);
        }
        const today = (0, moment_timezone_1.default)();
        // If the next open date is more than 6 days away, don't show a message
        // Otherwise, it might say "Open Monday" even though it's not the upcoming Monday, for example
        // TODO: This should be taken care of at the API level and not here. Move in the future
        if (eventDate.diff(today, "days") > 6) {
            return "";
        }
        // The decision was to show the "today" / "tomorrow" wording according to the user's locale
        // However, any other information (i.e. the time) should be specific to the location's locale
        // This is why the timezone is not set for todayWeekday
        // So, a message such as "Opens tomorrow at 8:00 a.m." could actually involve two different timezones!
        const todayWeekday = today.isoWeekday();
        const eventWeekday = eventDate.isoWeekday();
        const eventIsSoon = Math.abs(eventDate.diff(today, "days")) <= 2; // Just in case, for example, a location is open only on Mondays. This will ensure that it doesn't say "today" when it's really next Monday
        if (todayWeekday === eventWeekday && eventIsSoon) {
            finalMessageComponents.push(t("today"));
        }
        else if ((todayWeekday + 1) % 8 === eventWeekday && eventIsSoon) {
            finalMessageComponents.push(t("tomorrow"));
        }
        else {
            let dayOfWeek = (0, dayOfWeek_1.default)(eventDate.isoWeekday(), t);
            finalMessageComponents.push(dayOfWeek);
        }
        finalMessageComponents.push(t("at"));
        // The time shown should be specific to the location's timezone, not the user's timezone
        // toLocaleString always shows in user's timezone. Therefore, convert the eventDate to the computer's timezone
        // while keeping the location's hour and minute value (the location's timezone was set on eventDate)
        // so that the proper hour/minute value is shown.
        const hoursDate = new Date(2000, 1, 1, eventDate.hours(), eventDate.minutes());
        const locale = language + "-CA";
        const localeOptions = {
            hour: "numeric",
            minute: "numeric",
            hour12: language === "en",
        };
        finalMessageComponents.push(hoursDate.toLocaleString(locale, localeOptions));
        return finalMessageComponents.join(" ");
    }
    return "";
};
exports.locationAvailabilityMessage = locationAvailabilityMessage;
const calculateOpenCloseTime = (location, holidays, current_time = null, found = {
    opens_time: null,
    closes_time: null,
}, availability) => {
    var _a;
    if (!availability) {
        return { opens_time: null, closes_time: null };
    }
    if (found.opens_time !== null && found.closes_time !== null) {
        return found;
    }
    const tz = (_a = availability.timezone) !== null && _a !== void 0 ? _a : "America/Toronto";
    // Do any notices apply to opens_time?
    const notices = availability.notices.filter((n) => (current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz)).isBetween(n.start_time, n.end_time, undefined, "[)"));
    if (notices.length > 0) {
        if (
        // notice spans more than 7 days
        notices.some((n) => (0, moment_timezone_1.default)(n.start_time).diff(n.end_time, "days") >= 7)) {
            // Location is closed and not sure when it will reopen
            return { opens_time: null, closes_time: null };
        }
        // else: location is closed until last notice end_time
        return calculateOpenCloseTime(location, holidays, moment_timezone_1.default.tz(notices
            .map((n) => n.end_time) // get max end_time that applies
            .reduce(function (a, b) {
            return Math.max(a, b);
        }, 0), tz), found);
    }
    const isHomepageLocation = (location) => {
        return location.location_type !== undefined;
    };
    // No notices apply. Is opens_time a holiday or observed_holiday?
    const todays_hours = availability.hours[(0, dayOfWeek_1.dayOfWeekAsString)((current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz)).isoWeekday())].sort((a, b) => {
        const c = a.hour - b.hour;
        if (c !== 0)
            return c;
        const d = a.minute - b.minute;
        if (d !== 0)
            return d;
        return a.event_duration_minutes - b.event_duration_minutes;
    });
    if (holidays.some((h) => {
        const locationType = isHomepageLocation(location) ? location.location_type : location.moreContext['locationType'];
        const holidayAppliesToLocation = locationType === models_1.LocationType.SoCntr || h.stat;
        const holidayIsToday = (current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz)).isSame(moment_timezone_1.default.tz(h.date, "MM-DD-YYYY", tz), // TODO: Change this to use standard ISO date formatting
        "day");
        const serviceHolidayApplies = locationType === models_1.LocationType.SoCntr ||
            ["Christmas Day", "Boxing Day"].includes(h.english);
        const serviceHolidayIsToday = h.serviceHoliday &&
            (current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz)).isSame(h.serviceHoliday, "day");
        return (holidayAppliesToLocation &&
            (holidayIsToday || (serviceHolidayApplies && serviceHolidayIsToday)));
    }) ||
        todays_hours.length === 0) {
        // Location is closed today
        return calculateOpenCloseTime(location, holidays, (current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz)).add(1, "day"), found);
    }
    const now = (0, moment_timezone_1.default)().tz(tz);
    const minOpeningTime = (current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz))
        .startOf("day")
        .add(todays_hours[0].hour, "hours")
        .add(todays_hours[0].minute, "minutes");
    if (found.opens_time === null &&
        (!now.isSame(minOpeningTime, "day") || now.isBefore(minOpeningTime))) {
        return calculateOpenCloseTime(location, holidays, minOpeningTime, Object.assign(Object.assign({}, found), { opens_time: minOpeningTime.valueOf() }));
    }
    const maxClosingTime = (current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz))
        .startOf("day")
        .add(todays_hours[todays_hours.length - 1].hour, "hours")
        .add(todays_hours[todays_hours.length - 1].minute, "minutes")
        .add(todays_hours[todays_hours.length - 1].event_duration_minutes, "minutes");
    if (found.closes_time === null &&
        (!now.isSame(current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz), "day") ||
            now.isBefore(maxClosingTime))) {
        return calculateOpenCloseTime(location, holidays, minOpeningTime, Object.assign(Object.assign({}, found), { closes_time: minOpeningTime.valueOf() }));
    }
    return calculateOpenCloseTime(location, holidays, (current_time !== null && current_time !== void 0 ? current_time : (0, moment_timezone_1.default)().tz(tz)).add(1, "day"), found);
};
/* Updates location passed with new opens_time and closes_time */
const getOpenCloseTime = (location, holidays, availability) => {
    const retVal = {
        opens_time: null,
        closes_time: null
    };
    if (availability) {
        const timezone = availability.timezone;
        const currentTime = (0, moment_timezone_1.default)().tz(timezone);
        if (!availability.opens_time ||
            !availability.closes_time ||
            currentTime.isSameOrAfter(moment_timezone_1.default.tz(availability.opens_time, timezone)) ||
            currentTime.isSameOrAfter(moment_timezone_1.default.tz(availability.closes_time, timezone))) {
            const { opens_time, closes_time } = calculateOpenCloseTime(location, holidays, (0, moment_timezone_1.default)().tz(timezone).startOf("day"), availability);
            retVal.opens_time = opens_time;
            retVal.closes_time = closes_time;
        }
    }
    return retVal;
};
exports.getOpenCloseTime = getOpenCloseTime;
